import * as Yup from "yup";

const charRegex = /^(?=.*[a-zA-Z_])[a-zA-Z0-9_\s]+$/;
export const updateValidationSchema = Yup.object({
  Loc_Autocomplete_Name: Yup.string()
    .trim()
    .required("Location name is required"),
  // .max(25, 'Maximum 25 characters allowed'),
  Plot_Code: Yup.string()
    .trim()
    .required("Plotting code is required")
    .max(25, "Maximum 25 characters allowed")
    .matches(
      charRegex,
      "Location name must contain at least one letter and can include numbers and spaces"
    ),
  Plot_Name: Yup.string()
    .trim()
    .required("Plotting name is required")
    .matches(
      charRegex,
      "Location name must contain at least one letter and can include numbers and spaces"
    )
    .max(25, "Maximum 25 characters allowed"),
  // TODO: Plot area field should accept float value like : 1313.00
  Plot_Area: Yup.number()
    .typeError("Total Plotting area must be a number")
    .required("Total Plotting area is required")
    .moreThan(0, "Total Planting Count must be greater than 0")
    // .min(1, 'Total Plotting area must be greater than or equal to 1')
    .max(99999, "Total Planting area must be less than or equal to 99999")
    .test(
      "is-decimal",
      "Total Plot Area must have up to 2 decimal places",
      (value) => {
        if (value !== undefined) {
          return /^\d+(\.\d{0,2})?$/.test(value.toString());
        }
        return true; // Allow undefined values
      }
    ),
  // TODO: Plot area field should not accept float value like  : 8381983
  Total_Planting_Count: Yup.number()
    .integer("Total Planting Count should not be in decimal")
    .positive()
    .typeError("Total Planting Count must be a number")
    .required("Total Planting Count is required")
    .moreThan(0, "Total Planting Count must be greater than 0")
    .lessThan(100000, "Total Planting Count must be less than 100000"),
  // new changes - tag v3.0.1
  Land_Use: Yup.string().required("Land use is required field!"),
  Aspect: Yup.string().required("Aspect is required field!"),
  Soil_Texture: Yup.string().required("Soil Texture is required field!"),
  Presence_of_Weed_or_Grass: Yup.string().required("This field is required!"),
});

export const updateInitialValues = {
  Loc_Auto_ID: "",
  Plot_Code: "",
  Plot_Name: "",
  Plot_Area: "",
  Total_Planting_Count: "",
  Loc_Autocomplete_Name: "",
  // new changes - tag v3.0.1
  Land_Use: "",
  Aspect: "",
  Soil_Texture: "",
  Presence_of_Weed_or_Grass: "",
};
